import { FormState, Step } from "../types";

// ── Konstanter ────────────────────────────────────────────────────────────────
export const ALL_DIGITAL_VALUE = "Alla kommuner";
export const ALL_DIGITAL_LABEL = "Alla kommuner - digital aktivitet";
export const DIGITAL_TYPE = "Digitalt";
export const MAX_NAME = 60;
export const MAX_DESC = 800;

// ── Validering ────────────────────────────────────────────────────────────────
const REQUIRED_FIELDS: Record<Step, (keyof FormState)[]> = {
  1: ["startAcceptCriteria", "certificationStatus"],
  2: ["name", "description", "types", "ages", "municipalities", "addresses"],
  3: ["orgNumber", "email"],
  4: ["contactEmail", "newsletterOptIn", "agreePublish"],
  5: [],
};

const EMAIL_FIELDS = new Set<keyof FormState>(["email", "contactEmail"]);
const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const ORG_RE = /^(?=.*\d)[0-9-]+$/;

function isFilled(value: FormState[keyof FormState]): boolean {
  return Array.isArray(value) ? value.length > 0 : !!value;
}

function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value);
}

/** Gemensam valideringslogik för ett fält. */
function checkField(
  field: keyof FormState,
  value: FormState[keyof FormState],
  data?: FormState,
): boolean {
  if (field === "addresses" && data?.onlineOrNoSpecificAddress) return true;
  if (!isFilled(value)) return false;
  if (EMAIL_FIELDS.has(field) && !isValidEmail(String(value))) return false;
  if (field === "orgNumber" && !ORG_RE.test(String(value))) return false;
  return true;
}

/** Returnerar ett Set med fältnamn som inte klarar validering för givet steg. */
export function validateStep(step: Step, data: FormState): Set<string> {
  const errors = new Set<string>();
  for (const field of REQUIRED_FIELDS[step]) {
    if (!checkField(field, data[field], data)) errors.add(field);
  }
  return errors;
}

/** Returnerar ett Set med fältnamn som inte klarar validering för ett enskilt fält. */
export function validateField(
  field: keyof FormState,
  data: FormState,
): Set<string> {
  const errors = new Set<string>();
  const isRequired = Object.values(REQUIRED_FIELDS).some((fields) =>
    fields.includes(field),
  );
  if (isRequired && !checkField(field, data[field], data)) errors.add(field);
  return errors;
}

/** Formuläret är komplett om steg 1–4 alla klarar validering. */
export function isFormComplete(data: FormState): boolean {
  return ([1, 2, 3, 4] as Step[]).every(
    (s) => validateStep(s, data).size === 0,
  );
}
